// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-index[data-v-87c32416]{background-color:#eceef7;margin-top:-24px;min-height:calc(100dvh - 72px)}.btn__start-learning[data-v-87c32416]{max-width:248px;width:100%}@media screen and (min-width:1200px){.page-index[data-v-87c32416]{min-height:calc(100dvh - 76px)}}", ""]);
// Exports
module.exports = exports;
